import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// Link
import { Link } from "react-router-dom";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
// @material-ui/icons
import Explore from "@material-ui/icons/Explore";
import PlayArrow from "@material-ui/icons/PlayArrow";
import DoneIcon from "@material-ui/icons/Done";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import SimpleInfoArea from "components/SimpleInfoArea/SimpleInfoArea.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

import productStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/productStyle.jsx";

class CapabilityExplorerSection extends React.Component {
  render() {
    const { classes } = this.props;
    const typeformLink = process.env.REACT_APP_TYPEFORM_ID
      ? process.env.REACT_APP_TYPEFORM_ID
      : "https://capabilityexplorer.typeform.com/to/SCt0jP";
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>TEN Capability Explorer</h2>
            <h5 className={classes.description}>
              The TEN Capability Explorer is a tool designed to help you identify your current and future learning and teaching needs as part of your ongoing professional development. Aligned to the TEN Capability Framework, the tool will enable you to self-assess your professional skills and it will provide recommendations for suitable TEN PD modules.
            </h5>
            <h5 className={classes.description}>
              The TEN Capability Explorer is based on a survey, which asks you self-assessment questions about your skills and practices. The survey consists of seven parts, covering all seven domains of ‘teaching excellence’.
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
            <SimpleInfoArea
              title="What do the results tell me?"
              description="The TEN Capability Explorer provides you with:"
              vertical
            >
              <List dense>
                <ListItem>
                  - a summary of how you self-assess your capabilities in each of the seven domains
                </ListItem>
                <ListItem>
                  - recommendations for what TEN PD modules you might take, based on your responses
                </ListItem>
                <ListItem>
                  - your responses to the TEN Capability Explorer.
                </ListItem>
              </List>
            </SimpleInfoArea>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <SimpleInfoArea
              title="How does it work?"
              description="Once you complete the TEN Capability Explorer survey, you will receive an email with your results and professional development recommendations. You can use those recommendations to enrol in TEN PD modules. As they are recommendations, you may also decide to choose additional modules."
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <SimpleInfoArea
              title="Who has access to my results?"
              description="You and Learning and Teaching Services who administer this tool will have access to your results. If required, you may also share your results with your line manager to generate discussion regarding your professional development needs. Launch the TEN Capability Explorer below:"
              vertical
            />
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Capability Explorer"
              icon={Explore}
              iconColor="info"
              vertical
            />
            <a href={typeformLink} target="_blank" rel="noopener noreferrer">
              <Button style={{ width: "60%" }} type="button" color="info">
                <PlayArrow />
                Launch
              </Button>
            </a>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(productStyle)(CapabilityExplorerSection);
